import { useConfirmModal } from '@components/generic-modals';
import { IconReplace } from '@components/icons/replace';
import { showError } from '@components/toaster';
import { useScopedTranslate } from '@locale/translate';

import { useSyncToManualList } from './list-hooks';

import type { List } from '../integrations-types';

export const useChangeToManualModal = () => {
  const { t } = useScopedTranslate(locale);
  const showConfirmModal = useConfirmModal('LARGE');
  const changeSyncListMutation = useSyncToManualList();

  const showChangeToManualModal = (list: List) => {
    showConfirmModal({
      title: t('changeTitle'),
      description: t('changeModalText'),
      buttonText: t('changeButton'),
      buttonIcon: <IconReplace />,
      onConfirm: () => {
        if (list.sync) {
          changeSyncListMutation.mutateAsync(list.sync.shortId);
        } else {
          showError(t('couldNotChange'));
        }
      },
    });
  };

  return showChangeToManualModal;
};

const locale = {
  en: {
    changeTitle: 'Change synced list to a manual list',
    changeModalText:
      'You are about to change a synced list to a manual list.\nThis will remove the sync settings and the list will no longer be updated automatically.\n\nAre you sure you want to proceed?',
    changeButton: 'Change to manual',
    couldNotChange: 'Could not change list to manual',
  },
};
